import plural from 'helpers/plural';

angular.module('gym.waivers').controller('WaiverEditCtrl', ["$scope", "$rootScope", "$state", "$timeout", "$document", "$window", "$filter", "$http", "$q", "flash", "Waivers", "EmploymentService", "SubscriptionPlanLimitService", "GTMService", "loadingAnimation", "waiver", "membershipPlans", function($scope, $rootScope, $state, $timeout, $document, $window, $filter, $http, $q, flash, Waivers, EmploymentService, SubscriptionPlanLimitService, GTMService, loadingAnimation, waiver, membershipPlans) {
  var base, gym, isMember, isPaymentAuthorityAvailable, isProspect, isSectionAvailable, ref, safeApply, saveWaiver, scrollToFirstError, sortPlans, url, validate;
  gym = $scope.gym = $rootScope.gym;
  $scope.permissions = EmploymentService.get().permissions;
  $scope.country = gym.country;
  $scope.waiver = waiver;
  $scope.editableSectionTitles = {};
  $scope.pageParams = {};
  $scope.useNewEditor = $rootScope.gym.gym_config.use_slate_editor;
  $scope.currency = $rootScope.gym.currency_symbol;
  $scope.waiverAgeCheck = {
    selected: $scope.waiver.waiver_form_attributes.primary_signee_minimum_age ? 'has-minimum-age' : 'no-minimum-age'
  };
  $scope.waiverAgeValue = $scope.waiver.waiver_form_attributes.primary_signee_minimum_age || 18;
  $scope.getQuestionnairesForWaiver = null;
  $scope.changePrimaryMinAge = function(selectedOption) {
    if (selectedOption === 'no-minimum-age') {
      return $scope.waiver.waiver_form_attributes.primary_signee_minimum_age = null;
    } else if (selectedOption === 'has-minimum-age') {
      if (!$scope.waiver.waiver_form_attributes.primary_signee_minimum_age) {
        return $scope.waiver.waiver_form_attributes.primary_signee_minimum_age = $scope.waiverAgeValue;
      }
    }
  };
  if (waiver.waiver_header_attributes.default_logo_asset_id && !waiver.id) {
    url = `/gyms/${gym.id}/assets/${waiver.waiver_header_attributes.default_logo_asset_id}`;
    $http.get(url).then(function(response) {
      return $scope.defaultAsset = response.data;
    });
  }
  sortPlans = function(plans) {
    return _.sortBy(plans, function(plan) {
      var category, fixedLengthPosition, position, ref;
      category = (ref = plan.category) != null ? ref.label : void 0;
      position = waiver.waiver_form_attributes.membership_plan_ids.indexOf(plan.id);
      if (position < 0) {
        position = 99999;
      }
      fixedLengthPosition = $filter('padStart')(position, 9);
      return `${fixedLengthPosition}${category}`;
    });
  };
  if (!waiver.id) {
    $scope.waiver.waiver_form_attributes.share_payment_method_with_dependants = $rootScope.gym.gym_config.share_payment_method_with_dependants_default;
    $scope.waiver.waiver_form_attributes.family_membership_strategy = $rootScope.gym.gym_config.family_membership_strategy_default;
  }
  $scope.membershipPlans = sortPlans(membershipPlans.map(function(plan) {
    plan.selected = waiver.waiver_form_attributes.membership_plan_ids.indexOf(plan.id) > -1;
    plan.default = waiver.waiver_form_attributes.default_membership_plan_id === plan.id;
    return plan;
  }));
  $scope.emailToolbar = [['bold', 'italics', 'underline', 'ul', 'ol', 'justifyLeft', 'justifyCenter', 'justifyRight', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'insertHttpsLink']];
  $scope.nonEmailToolbar = [['italics', 'underline', 'ul', 'ol', 'justifyLeft', 'justifyCenter', 'justifyRight', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'insertHttpsLink']];
  if (waiver.gym_payment_provider === 'ezidebit') {
    (base = $scope.waiver.waiver_form_attributes).payment_authority_preferred_payment_method || (base.payment_authority_preferred_payment_method = 'credit_card');
  }
  $scope.callToActionButtonEnabled = !!$scope.waiver.waiver_form_attributes.complete_page_button_label || !!$scope.waiver.waiver_form_attributes.complete_page_button_url;
  $scope.toggleCTAContent = function() {
    $scope.waiver.waiver_form_attributes.complete_page_button_url = '';
    return $scope.waiver.waiver_form_attributes.complete_page_button_label = '';
  };
  $scope.onQuestionnaireVisibilityChanged = function() {
    var active;
    active = $scope.waiver.waiver_form_attributes.questionnaires_active;
    if (active && $scope.lastQuestionnaireValidationErrors && typeof $scope.setQuestionnaireValidationErrors === 'function') {
      $scope.setQuestionnaireValidationErrors($scope.lastQuestionnaireValidationErrors);
    }
    if (!active && typeof $scope.getQuestionnairesForWaiver === 'function') {
      return $scope.waiver.waiver_contact_questionnaires_attributes = $scope.getQuestionnairesForWaiver();
    }
  };
  $scope.readOnlyRequiredFields = {
    _name: 'required_for_all_signees',
    email: 'required_for_all_signees'
  };
  $scope.requiredFieldsLabel = function(key) {
    var labels;
    labels = {
      _name: 'First / last name',
      address: 'Address',
      dob: 'Date of Birth',
      member_number: 'Member Number',
      phone_number: 'Phone Number'
    };
    return labels[key] || $filter('humanize')(key);
  };
  $scope.requiredLabel = function(field) {
    switch ($scope.waiver.waiver_form_attributes.required_fields[field]) {
      case 'required_for_all_signees':
        return ' (Required)';
      case 'required_for_primary_signee':
        return ' (Primary only)';
      default:
        return '';
    }
  };
  $scope.isFieldAvailable = function(field) {
    return $scope.waiver.waiver_form_attributes.required_fields[field] !== 'hidden';
  };
  if ($scope == null) {
    $scope = {};
  }
  $scope.getPurchaseLimitLabel = function(plan) {
    if (plan.purchase_limit > 0 && plan.purchases_remaining) {
      return `${plan.purchase_limit} (${plan.purchases_remaining} remaining)`;
    } else if (plan.purchase_limit > 0 && !plan.purchases_remaining) {
      return `${plan.purchase_limit} (Sold out)`;
    } else {
      return 'N/A';
    }
  };
  $scope.isSectionVisible = function(section) {
    return isSectionAvailable(section) && isPaymentAuthorityAvailable(section);
  };
  $scope.isMember = isMember = function() {
    return $scope.waiver.waiver_type === 'member';
  };
  $scope.isProspect = isProspect = function() {
    return $scope.waiver.waiver_type === 'prospect';
  };
  $scope.waiverTypeSelected = function() {
    return $scope.waiver.waiver_type;
  };
  validate = function() {
    var deferred;
    deferred = $q.defer();
    $scope.waiver.errors = {};
    $http.post(`/gyms/${gym.id}/waivers/waivers/validate`, $scope.waiver).then(function(response) {
      return deferred.resolve();
    }, function(response) {
      loadingAnimation.hide();
      $scope.waiver.errors = response.data.errors;
      return deferred.reject(response);
    });
    return deferred.promise;
  };
  isSectionAvailable = function(section) {
    if (!$scope.waiver.waiver_type) {
      return;
    }
    if (isMember()) {
      return true;
    } else {
      return section === 'gymInfo' || section === 'contactDetails' || section === 'gymTacs' || section === 'waiverRelease' || section === 'electronicConsent' || section === 'questionnaires' || section === 'completedPage' || section === 'signature' || section === 'witnessDetails';
    }
  };
  isPaymentAuthorityAvailable = function(section) {
    var paymentSystem, ref;
    paymentSystem = (ref = gym.payment_system) != null ? ref.toLowerCase() : void 0;
    if (section === 'paymentAuthority') {
      return paymentSystem === 'ezidebit' || paymentSystem === 'stripe';
    } else {
      return true;
    }
  };
  $scope.isForSingleAdults = function() {
    return $scope.waiver.allow_signing_by === 'adult';
  };
  $scope.isWalletSharingAvailable = function() {
    var enabled;
    enabled = !!_.find($rootScope.gym.payment_providers, function(provider) {
      return provider === 'ezidebit' || provider === 'bluefin' || provider === 'stripe';
    });
    return enabled && !$scope.isForSingleAdults();
  };
  $scope.onWaiverTypeChanged = function() {
    $scope.waiver.waiver_form_attributes.membership_options_active = isMember() && $scope.membershipPlans.length;
    $scope.waiver.waiver_form_attributes.contact_details_title = isMember() ? 'Member Details' : 'Contact Information';
    return $scope.waiver.waiver_form_attributes.accept_member_number = false;
  };
  $scope.updatePlansPosition = function() {
    var waiverForm;
    waiverForm = $scope.waiver.waiver_form_attributes;
    return waiverForm.membership_plan_ids = $scope.membershipPlans.filter(function(item) {
      return item.selected;
    }).map(function(item) {
      return item.id;
    });
  };
  $scope.updatePlansDefault = function(plan) {
    if ($scope.waiver.waiver_form_attributes.default_membership_plan_id === plan.id) {
      $scope.waiver.waiver_form_attributes.default_membership_plan_id = null;
      return plan.default = false;
    } else {
      $scope.waiver.waiver_form_attributes.default_membership_plan_id = plan.id;
      return $scope.membershipPlans.forEach(function(item) {
        return item.default = item.id === plan.id;
      });
    }
  };
  $scope.onPaymentAuthorityToggle = function() {
    var form;
    form = $scope.waiver.waiver_form_attributes;
    $scope.waiver.waiver_form_attributes.signature_active = true;
    if (!form.payment_authority_active) {
      return form.payment_authority_privacy_policy_checkbox_active = false;
    }
  };
  $scope.onSignatureToggle = function() {
    var ref, ref1, ref2, ref3, ref4, ref5;
    if ((ref = $scope.waiver) != null ? (ref1 = ref.waiver_form_attributes) != null ? ref1.payment_authority_active : void 0 : void 0) {
      return (ref2 = $scope.waiver) != null ? (ref3 = ref2.waiver_form_attributes) != null ? ref3.signature_active = true : void 0 : void 0;
    } else {
      return (ref4 = $scope.waiver) != null ? (ref5 = ref4.waiver_form_attributes) != null ? ref5.witness_signature_active = false : void 0 : void 0;
    }
  };
  $scope.onWitnessSignatureToggle = function() {
    var ref, ref1, ref2, ref3;
    if (((ref = $scope.waiver) != null ? (ref1 = ref.waiver_form_attributes) != null ? ref1.signature_active : void 0 : void 0) === false) {
      return (ref2 = $scope.waiver) != null ? (ref3 = ref2.waiver_form_attributes) != null ? ref3.witness_signature_active = false : void 0 : void 0;
    }
  };
  $scope.isGDPR = function() {
    var form;
    form = $scope.waiver.waiver_form_attributes;
    return form.show_contact_age_check_privacy_policy_choice || form.show_contact_information_privacy_policy_choice || form.show_payment_authority_privacy_policy_choice;
  };
  $scope.registerQuestionnaireBuilder = function(builderFn, setErrorsFn = null) {
    $scope.getQuestionnairesForWaiver = builderFn;
    return $scope.setQuestionnaireValidationErrors = setErrorsFn;
  };
  saveWaiver = function() {
    var waiverForm;
    waiverForm = $scope.waiver.waiver_form_attributes;
    if (!($scope.waiver.waiver_header_attributes.logo_asset_id || $scope.waiver.waiver_header_attributes.logo_url)) {
      $scope.waiver.waiver_header_attributes.logo_asset_id = $scope.waiver.waiver_header_attributes.default_logo_asset_id;
    }
    if ($scope.waiver.waiver_form_attributes.questionnaires_active) {
      $scope.waiver.waiver_contact_questionnaires_attributes = $scope.getQuestionnairesForWaiver();
    }
    if (waiverForm.receipt_email_subject) {
      waiverForm.receipt_email_subject = $filter('sanitizeEditorField')(waiverForm.receipt_email_subject, true, {
        target: 'subject'
      });
    }
    if (waiverForm.attached_email_subject) {
      waiverForm.attached_email_subject = $filter('sanitizeEditorField')(waiverForm.attached_email_subject, true, {
        target: 'subject'
      });
    }
    if (waiverForm.prefill_email_subject) {
      waiverForm.prefill_email_subject = $filter('sanitizeEditorField')(waiverForm.prefill_email_subject, true, {
        target: 'subject'
      });
    }
    if ($scope.waiver.id) {
      return $scope.waiver.save();
    } else {
      return Waivers.post($scope.waiver);
    }
  };
  $scope.save = function() {
    var base1;
    GTMService.trackPage('Waivers new', 'Save draft');
    loadingAnimation.show();
    (base1 = $scope.waiver).errors || (base1.errors = {});
    delete $scope.waiver.errors.questionnaire;
    $scope.hasQuestionnaireErrors = false;
    $scope.hasQuestionnaireValidationErrors = false;
    return $q.all([
      (function() {
        var deferred,
      err,
      result;
        deferred = $q.defer();
        try {
          if ($scope.waiver.waiver_form_attributes.questionnaires_active && typeof $scope.validateQuestionnairesWrapped === 'function') {
            result = $scope.validateQuestionnaires(function(isValid,
      rawErrors = {}) {
              safeApply(function() {
                var base2,
      base3;
                $scope.hasQuestionnaireErrors = !isValid;
                $scope.hasQuestionnaireValidationErrors = !isValid;
                if (!isValid) {
                  (base2 = $scope.waiver).errors || (base2.errors = {});
                  (base3 = $scope.waiver.errors).questionnaire || (base3.questionnaire = []);
                  $scope.waiver.errors.questionnaire.push('Some questionnaire questions are invalid.');
                  $scope.lastQuestionnaireValidationErrors = rawErrors;
                  if (typeof $scope.setQuestionnaireValidationErrors === 'function') {
                    $scope.setQuestionnaireValidationErrors(rawErrors);
                  }
                  if (!$scope.waiver.waiver_form_attributes.questionnaires_active) {
                    $scope.waiver.waiver_form_attributes.questionnaires_active = true;
                    return $timeout(function() {
                      $scope.onQuestionnaireVisibilityChanged();
                      return $timeout(function() {
                        if (typeof $scope.setQuestionnaireValidationErrors === 'function') {
                          return $scope.setQuestionnaireValidationErrors($scope.lastQuestionnaireValidationErrors);
                        }
                      },
      0);
                    });
                  }
                } else {
                  delete $scope.waiver.errors.questionnaire;
                  return $scope.lastQuestionnaireValidationErrors = null;
                }
              });
              return deferred.resolve(isValid);
            });
            if (typeof result === 'boolean') {
              safeApply(function() {
                var base2,
      base3;
                $scope.hasQuestionnaireErrors = !result;
                $scope.hasQuestionnaireValidationErrors = !result;
                if (!result) {
                  (base2 = $scope.waiver).errors || (base2.errors = {});
                  (base3 = $scope.waiver.errors).questionnaire || (base3.questionnaire = []);
                  return $scope.waiver.errors.questionnaire.push('Some questionnaire questions are invalid.');
                }
              });
              deferred.resolve(result);
            }
          } else {
            deferred.resolve(true);
          }
        } catch (error) {
          err = error;
          deferred.resolve(false);
        }
        return deferred.promise;
      })()
    ]).then(function([questionnaireValid]) {
      if (!questionnaireValid) {
        $scope.hasQuestionnaireErrors = true;
        loadingAnimation.hide();
        flash.error = 'Save failed. Please fix the errors below';
        $timeout(function() {
          return scrollToFirstError();
        }, 300);
        return;
      }
      return saveWaiver().then(function(response) {
        var base2, base3;
        if ($scope.hasQuestionnaireErrors) {
          loadingAnimation.hide();
          (base2 = $scope.waiver).errors || (base2.errors = {});
          (base3 = $scope.waiver.errors).questionnaire || (base3.questionnaire = []);
          $scope.waiver.errors.questionnaire.push('Some questionnaire questions are invalid.');
          $timeout(function() {
            return scrollToFirstError();
          }, 300);
          flash.error = 'Save failed. Please fix the errors below';
          return;
        }
        loadingAnimation.hide();
        return $state.go('gym.waivers.list');
      }).catch(function(response) {
        var base2;
        loadingAnimation.hide();
        $scope.waiver.errors = response.data.errors || {};
        if ($scope.hasQuestionnaireErrors) {
          (base2 = $scope.waiver.errors).questionnaire || (base2.questionnaire = []);
          $scope.waiver.errors.questionnaire.push('Some questionnaire questions are invalid.');
        }
        $timeout(function() {
          return scrollToFirstError();
        }, 100);
        return flash.error = 'Save failed. Please fix the errors below';
      });
    });
  };
  scrollToFirstError = function() {
    return $window.requestAnimationFrame(function() {
      return $timeout(function() {
        var allErrorElements, filteredErrorElements, topmostEl, topmostOffset;
        allErrorElements = Array.from(document.querySelectorAll('.alert-danger, .questionnaire-error-anchor, .questionnaire-validation-notice'));
        filteredErrorElements = allErrorElements.filter(function(el) {
          if (el.classList.contains('questionnaire-validation-notice')) {
            return !$scope.waiver.waiver_form_attributes.questionnaires_active;
          } else {
            return true;
          }
        });
        topmostEl = null;
        topmostOffset = 2e308;
        filteredErrorElements.forEach(function(el) {
          var offset, rect;
          rect = el.getBoundingClientRect();
          offset = rect.top + window.scrollY;
          if (offset < topmostOffset) {
            topmostOffset = offset;
            return topmostEl = el;
          }
        });
        if (topmostEl != null) {
          return window.scrollTo({
            top: topmostOffset - 300,
            behavior: 'smooth'
          });
        } else {
          return $document.scrollTop(0);
        }
      });
    });
  };
  $scope.planCategory = function(plan) {
    var ref;
    return (ref = plan.category) != null ? ref.label : void 0;
  };
  $scope.validateQuestionnaires = null;
  $scope.hasQuestionnaireValidationErrors = false;
  $scope.registerQuestionnaireValidator = function(fn) {
    return $scope.validateQuestionnaires = fn;
  };
  $scope.registerQuestionnaireErrorSetter = function(fn) {
    return $scope.setQuestionnaireValidationErrors = fn;
  };
  $scope.validateQuestionnairesWrapped = function(callback) {
    if (!($scope.waiver.waiver_form_attributes.questionnaires_active && typeof $scope.validateQuestionnaires === 'function')) {
      return callback(true);
    }
    return $scope.validateQuestionnaires(function(isValid, rawErrors) {
      var errors, flatMessages;
      errors = angular.isObject(rawErrors) ? rawErrors : {};
      flatMessages = [];
      angular.forEach(errors, function(arr) {
        if (angular.isArray(arr)) {
          return flatMessages = flatMessages.concat(arr);
        }
      });
      return safeApply(function() {
        var base1;
        $scope.hasQuestionnaireErrors = !isValid;
        $scope.hasQuestionnaireValidationErrors = !isValid;
        (base1 = $scope.waiver).errors || (base1.errors = {});
        if (!isValid) {
          $scope.waiver.errors.questionnaire = flatMessages.length ? flatMessages : ['Some questionnaire questions are invalid.'];
          if (typeof $scope.setQuestionnaireValidationErrors === 'function') {
            $scope.setQuestionnaireValidationErrors(errors);
            $scope.lastQuestionnaireValidationErrors = errors;
          }
        } else {
          delete $scope.waiver.errors.questionnaire;
          $scope.lastQuestionnaireValidationErrors = null;
        }
        return callback(isValid);
      });
    });
  };
  safeApply = function(fn) {
    if (!$scope.$$phase && !$scope.$root.$$phase) {
      return $scope.$apply(fn);
    } else {
      return fn();
    }
  };
  $scope.saveAndPublish = function() {
    var base1, oldDraftValue, oldShowOnWeb;
    GTMService.trackPage('Waivers new', 'Save+Publish');
    loadingAnimation.show();
    (base1 = $scope.waiver).errors || (base1.errors = {});
    delete $scope.waiver.errors.questionnaire;
    $scope.hasQuestionnaireErrors = false;
    $scope.hasQuestionnaireValidationErrors = false;
    oldDraftValue = $scope.waiver.draft;
    oldShowOnWeb = $scope.waiver.show_on_web;
    $scope.saveAndPublishProcessing = true;
    $scope.waiver.draft = false;
    $scope.waiver.show_on_web = true;
    return $q.all([
      (function() {
        var called,
      deferred;
        deferred = $q.defer();
        if ($scope.waiver.waiver_form_attributes.questionnaires_active && typeof $scope.validateQuestionnaires === 'function') {
          called = false;
          $scope.validateQuestionnairesWrapped(function(isValid) {
            if (called) {
              return;
            }
            called = true;
            safeApply(function() {
              $scope.hasQuestionnaireErrors = !isValid;
              return $scope.hasQuestionnaireValidationErrors = !isValid;
            });
            return deferred.resolve(isValid);
          });
          $timeout(function() {
            if (!called) {
              safeApply(function() {
                $scope.hasQuestionnaireErrors = true;
                return $scope.hasQuestionnaireValidationErrors = true;
              });
              return deferred.resolve(false);
            }
          },
      2000);
        } else {
          deferred.resolve(true);
        }
        return deferred.promise;
      })(),
      validate()
    ]).then(function([questionnaireValid]) {
      if (!questionnaireValid) {
        loadingAnimation.hide();
        flash.error = 'Save failed. Please fix the errors below';
        $timeout(function() {
          return scrollToFirstError();
        }, 300);
        return;
      }
      return saveWaiver().then(function(response) {
        loadingAnimation.hide();
        return $state.go('gym.waivers.list');
      }).catch(function(response) {
        var base2;
        loadingAnimation.hide();
        $scope.waiver.draft = oldDraftValue;
        $scope.waiver.show_on_web = oldShowOnWeb;
        $scope.waiver.errors = response.data.errors || {};
        SubscriptionPlanLimitService.validate(response.data);
        if ($scope.hasQuestionnaireErrors) {
          (base2 = $scope.waiver.errors).questionnaire || (base2.questionnaire = []);
          $scope.waiver.errors.questionnaire.push('Some questionnaire questions are invalid.');
        }
        scrollToFirstError();
        return flash.error = 'Save failed. Please fix the errors below';
      });
    }).catch(function(err) {
      var base2, base3, ref;
      loadingAnimation.hide();
      $scope.waiver.draft = oldDraftValue;
      $scope.waiver.show_on_web = oldShowOnWeb;
      flash.error = 'Save failed. Please fix the errors below';
      (base2 = $scope.waiver).errors || (base2.errors = {});
      if (err != null ? (ref = err.data) != null ? ref.errors : void 0 : void 0) {
        $scope.waiver.errors = err.data.errors;
      }
      if ($scope.hasQuestionnaireErrors) {
        (base3 = $scope.waiver.errors).questionnaire || (base3.questionnaire = []);
        $scope.waiver.errors.questionnaire.push('Some questionnaire questions are invalid.');
      }
      return $timeout(function() {
        return scrollToFirstError();
      }, 300);
    });
  };
  $scope.onLogoChange = function(image) {
    $scope.waiver.waiver_header_attributes.logo_asset_id = image.id;
    return $scope.waiver.waiver_header_attributes.logo_url = image.thumb_url;
  };
  $scope.getLogo = function() {
    var ref;
    return $scope.waiver.waiver_header_attributes.logo_url || ((ref = $scope.defaultAsset) != null ? ref.thumb_url : void 0);
  };
  $scope.isFreeTrialRemindMessageAvailable = $rootScope.gym.on_trial_period && $rootScope.gym.trialling_highest_plan;
  $scope.toggleManageRequiredFields = function(value) {
    return $scope.manageRequiredFieldsVisible = value;
  };
  $scope.plan = 'Accelerating';
  $scope.membershipPlansSortableParams = {
    handle: '.worx-item-handle-container',
    forcePlaceholderSize: true,
    stop: function() {
      return $scope.updatePlansPosition();
    }
  };
  $scope.onFamilyMembershipStrategyChange = function() {
    var waiverForm;
    waiverForm = $scope.waiver.waiver_form_attributes;
    if (waiverForm.family_membership_strategy !== 'only_parent_pays_membership' && waiverForm.payment_authority_active && !waiverForm.share_payment_method_with_dependants) {
      waiverForm.share_payment_method_with_dependants = true;
      return $scope.displayPaymentMethodSharingEnabledMessage = true;
    }
  };
  $scope.onSharePaymentMethodChange = function() {
    return $scope.displayPaymentMethodSharingEnabledMessage = $scope.waiver.waiver_form_attributes.share_payment_method_with_dependants;
  };
  $scope.onRestrictPaymentMethodsChange = function(enabled) {
    if (!enabled) {
      return $scope.waiver.waiver_form_attributes.restrict_payment_methods_to = [];
    }
  };
  $scope.restrictPaymentMethods = !!((ref = $scope.waiver.waiver_form_attributes.restrict_payment_methods_to) != null ? ref.length : void 0);
  $scope.onRestrictPaymentMethodsSelect = function(value) {
    return $scope.waiver.waiver_form_attributes.restrict_payment_methods_to = [value];
  };
  return $scope.goToPaymentSetting = function() {
    $scope.waiver.waiver_form_attributes.payment_authority_active = true;
    return $timeout(function() {
      return $document.scrollToElementAnimated(angular.element('#wallet-sharing-toggle'));
    }, 100);
  };
}]);
